import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import {fetchVendorById, updateVendor} from "../../store/vendor-slice";
import {getFormData} from "../../models/vendorModel";
import {vendorSchema} from "../../schema/vendorSchema";
import Form from "../../components/common/form/Form";
import {fetchExpenseList} from "../../store/list-slice";

const VendorEdit = () => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.user);
    const {limit, currentPage} = getValidatedLimit(pagination);
    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);

    const {
        items: vendors,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.vendor); // Adjust this selector to your user slice

    useEffect(() => {
        dispatch(fetchVendorById({...userRole, id: params.vendorId})); // Ensure you're using the correct ID parameter
    }, [dispatch, params.vendorId, userRole]);

    const vendor = vendors.find(vendor => vendor.id === params.vendorId); // Ensure correct ID matching

    useEffect(() => {
        if (updateStatus === "success") {
            navigate(`../../?page=${currentPage}&limit=${limit}`); // Adjust navigation as needed
        }
    }, [updateStatus, navigate, currentPage, limit]);

    useEffect(() => {
        dispatch(fetchExpenseList())
    }, [dispatch])

    const formSubmitHandler = (data) => {
        dispatch(updateVendor({...userRole, data, id: params.vendorId})); // Ensure this action is correctly defined
    };

    const formCancelHandler = () => {
        navigate(`../../?page=${currentPage}&limit=${limit}`); // Adjust navigation as needed
    };

    const schema = vendorSchema({list}); // Adjust the schema as necessary
    const initialData = getFormData(vendor); // Make sure getFormData is correctly implemented for user data

    return (<>
            <SubHeader title="Update Vendor">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form
                                onFormSubmit={formSubmitHandler}
                                onFormCancel={formCancelHandler}
                                schema={schema}
                                inline={false}
                                initialData={initialData}
                                status={updateStatus}
                                error={error}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default VendorEdit;